/**
 * 診断値を安全に表示可能な文字列へ変換する
 *
 * @param value - 診断値
 * @returns 表示文字列
 */
export const formatDiagnosticValue = (value: unknown) => {
  if (value === null || value === undefined) {
    return "情報なし";
  }

  if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }

  try {
    return JSON.stringify(value, null, 2);
  } catch (error: unknown) {
    console.error("Failed to format diagnostic value", error);
    return "表示できない情報です";
  }
};
